module.exports = __webpack_public_path__ + "img/img-in-modal.948aa84.webp";